module.exports = __webpack_public_path__ + "static/media/YL_getfreelisting_Desktop_EN.f2a8120d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YL_getfreelisting_Desktop_EN.png
// module id = 704
// module chunks = 0